import React, { useEffect, useState } from 'react';
import { Col, Row, Card } from 'react-bootstrap';
//import Account from './Account';
import { Link } from 'react-router-dom';
import Avatar, { AvatarGroup } from 'components/common/Avatar';
import Flex from 'components/common/Flex';
import user1 from 'assets/img/team/1.jpg';
import user2 from 'assets/img/team/2.jpg';
import user3 from 'assets/img/team/3.jpg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import IconButton from 'components/common/IconButton';
//import Charging from 'components/common/Charging';
//import TableContracts from './TableContracts';
//import useLoan from './useLoan';
import Input from 'components/common/Input';
//import ContractSettings from './ContractSettings';

import dayjs from 'dayjs';
import { currency, percent } from 'helpers/utils';
import { useForm } from 'react-hook-form';
import Background from 'components/common/Background';
import Dues from './Dues';
import bg2 from 'assets/img/icons/spot-illustrations/corner-2.png';
import classNames from 'classnames';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isBetween from 'dayjs/plugin/isBetween';

dayjs.extend(isSameOrBefore);
dayjs.extend(isBetween);

const Loans = () => {
 const [data, setData] = useState([]);

 const {
  watch,
  //setValue,
  register,
  formState: { errors }
 } = useForm({
  defaultValues: {
   principal: 10000000,
   tasaInteres: 20,
   tiempo: 24,
   primeraFecha: '2023-05-02',
   periodoPago: 'mensual',
   frecuenciaPagos: 'mensual',
   abonos: [
    { montoAbono: 2025478.7303089749, fechaAbono: '2023-07-01', formaPago: 1 },
    { montoAbono: 2000000, fechaAbono: '2023-08-08', formaPago: 1 },
    { montoAbono: 4000000, fechaAbono: '2023-08-15', formaPago: 2 }
   ]
  }
 });

 // Función para calcular cuotas detalladas con interés compuesto y fechas de pago
 /* 
    calcularCuotasDetalladas que calcula los detalles de las cuotas de un préstamo con diferentes opciones de periodo de pago y frecuencia de pagos. Aquí tienes un resumen de cómo funciona la función:

Se calcula la tasa de interés periódica utilizando la tasa de interés anual proporcionada.
Se calcula el número total de períodos de pago basado en el periodoPago seleccionado.
Se calcula la cuota fija periódica utilizando la fórmula de interés compuesto.
Se ajusta el número y el valor de las cuotas según la frecuencia de pagos seleccionada dentro de cada periodo.
Se inician las variables necesarias para el cálculo de cuotas y fechas.
Se realizan los cálculos de intereses, capital pagado y saldo pendiente para el primer periodo.
Se ajusta el montoCuota y esPeriodica para manejar el caso de frecuencias de pagos superiores a la cuota periódica.
Se itera a través de cada cuota y se calculan las fechas límite de pago, fechas de periodo y otras variables relacionadas con el cálculo.
Se van acumulando los detalles de cada cuota en el arreglo cuotasDetalladas.
Al final del cálculo de cuotas, se calculan los totales de intereses pagados y cuotas pagadas.
     */
 function calcularCuotasDetalladas(principal, tasaInteres, tiempo, periodoPago, primeraFecha, frecuenciaPagos, numCuota = 1) {
  // Calcular la tasa de interés periódica
  const tasaInteresPeriodica = tasaInteres / 100; // Suponiendo pagos mensuales

  // Calcular el número total de períodos de pago basado en el periodoPago elegido
  const totalPeriodosPago = {
   diario: tiempo * 30,
   semanal: tiempo * 4,
   quincenal: tiempo * 2,
   mensual: tiempo * 1
  }[periodoPago];

  // Calcular la cuota fija periódica utilizando la fórmula de interés compuesto
  const cuotaPeriodica = (principal * tasaInteresPeriodica) / (1 - Math.pow(1 + tasaInteresPeriodica, -totalPeriodosPago));

  // Ajustar el número de cuotas según la frecuencia de pagos seleccionada dentro de cada periodo
  const frecuencia = {
   diario: tiempo * 30,
   semanal: tiempo * 4,
   quincenal: tiempo * 2,
   mensual: tiempo
  }[frecuenciaPagos];

  // Ajustar el valor de las cuotas según la frecuencia de pagos seleccionada dentro de cada periodo
  const cuotaFrecuencia = {
   diario: {
    diario: [cuotaPeriodica, '/1'],
    semanal: [cuotaPeriodica / 7, '/7'],
    quincenal: [cuotaPeriodica / 15, '/15'],
    mensual: [cuotaPeriodica / 30, '/30']
   }[periodoPago],
   semanal: {
    diario: [cuotaPeriodica * 7, '*7'],
    semanal: [cuotaPeriodica, '/1'],
    quincenal: [cuotaPeriodica / 2, '/2'],
    mensual: [cuotaPeriodica / 4, '/4']
   }[periodoPago],
   quincenal: {
    diario: [cuotaPeriodica * 15, '*15'],
    semanal: [cuotaPeriodica * 2, '*2'],
    quincenal: [cuotaPeriodica, '/1'],
    mensual: [cuotaPeriodica / 2, '/2']
   }[periodoPago],
   mensual: {
    diario: [cuotaPeriodica * 30, '*30'],
    semanal: [cuotaPeriodica * 4, '*4'],
    quincenal: [cuotaPeriodica * 2, '*2'],
    mensual: [cuotaPeriodica, '/1']
   }[periodoPago]
  }[frecuenciaPagos];

  // Calcular las cuotas detalladas y las fechas de pago
  const cuotasDetalladas = [];
  let saldoPendiente = principal;
  let fechaPago = dayjs(primeraFecha).startOf('day'); // Usar la primeraFecha proporcionada
  let fechaPeriodo = dayjs(primeraFecha).startOf('day'); // Usar la primeraFecha proporcionada

  let interesPeriodo = saldoPendiente * tasaInteresPeriodica; // Interés para este período
  let capitalPagado = cuotaPeriodica - interesPeriodo; // Capital pagado para este período
  saldoPendiente -= capitalPagado; // Actualizar el saldo pendiente después del pago
  let montoCuota = cuotaPeriodica;
  let esPeriodica = true;

  if (cuotaFrecuencia[0] > cuotaPeriodica) {
   let intrs = interesPeriodo;
   let capital = capitalPagado;
   Array.from(Array(cuotaFrecuencia[1].replace(/[^0-9]/g, '') - 1).keys()).map(() => {
    console.log({ saldoPendiente, interesPeriodo, capitalPagado, cuotaPeriodica, intrs, capital });
    interesPeriodo = saldoPendiente * tasaInteresPeriodica; // Interés para este período
    capitalPagado = cuotaPeriodica - interesPeriodo; // Capital pagado para este período
    saldoPendiente -= capitalPagado; // Actualizar el saldo pendiente después del pago
    intrs += interesPeriodo;
    capital += capitalPagado;
    console.log({ saldoPendiente, interesPeriodo, capitalPagado, cuotaPeriodica, intrs, capital }, 'luego');
   });
   interesPeriodo = intrs;
   capitalPagado = capital;
  }

  for (let cuota = 0; cuota < frecuencia; cuota++) {
   if (montoCuota < 1) {
    interesPeriodo = saldoPendiente * tasaInteresPeriodica; // Interés para este período
    capitalPagado = cuotaPeriodica - interesPeriodo; // Capital pagado para este período
    saldoPendiente -= capitalPagado; // Actualizar el saldo pendiente después del pago
    montoCuota = cuotaPeriodica;
    esPeriodica = true;
    if (cuotaFrecuencia[0] > cuotaPeriodica) {
     let intrs = interesPeriodo;
     let capital = capitalPagado;
     Array.from(Array(cuotaFrecuencia[1].replace(/[^0-9]/g, '') - 1).keys()).map(() => {
      console.log({ saldoPendiente, interesPeriodo, capitalPagado, cuotaPeriodica, intrs, capital });
      interesPeriodo = saldoPendiente * tasaInteresPeriodica; // Interés para este período
      capitalPagado = cuotaPeriodica - interesPeriodo; // Capital pagado para este período
      saldoPendiente -= capitalPagado; // Actualizar el saldo pendiente después del pago
      intrs += interesPeriodo;
      capital += capitalPagado;
      console.log({ saldoPendiente, interesPeriodo, capitalPagado, cuotaPeriodica, intrs, capital }, 'luego');
     });
     interesPeriodo = intrs;
     capitalPagado = capital;
    }
   }

   montoCuota -= cuotaFrecuencia[0];

   // Establecer la fecha límite de pago según la frecuencia de pagos seleccionada
   const fechaLimitePago = {
    diario: fechaPago.endOf('day'),
    semanal: fechaPago.add(1, 'week').subtract(1, 'day'),
    quincenal: fechaPago.add(15, 'day').subtract(1, 'day'),
    mensual: fechaPago.add(1, 'month').subtract(1, 'day')
   }[frecuenciaPagos];

   // Agregar la información de la cuota detallada a la lista de cuotasDetalladas
   cuotasDetalladas.push({
    numeroCuota: numCuota + cuota, // Número de cuota
    fechaPago: fechaPago.format('YYYY-MM-DD'), // Fecha de pago en formato 'YYYY-MM-DD'
    fechaPeriodo: fechaPeriodo.format('YYYY-MM-DD'), // Fecha del periodo
    fechaLimitePago: fechaLimitePago.format('YYYY-MM-DD'), // Fecha límite de pago en formato 'YYYY-MM-DD'
    cuotaPeriodo: cuotaPeriodica, // Cuota fija para este período
    cuotaFija: cuotaFrecuencia[0], // Cuota fija para la frecuencia
    cuotaFracmentada: cuotaFrecuencia[1], // Fracmentacion de la cuota del periodo
    interesPagado: esPeriodica ? interesPeriodo : 0, // Interés pagado para este período
    capitalPagado: esPeriodica ? capitalPagado : 0, // Capital pagado para este período
    saldoCapital: esPeriodica && saldoPendiente > 0 ? saldoPendiente : 0, // Saldo de capital pendiente después del pago
    saldoInteres: esPeriodica && saldoPendiente * tasaInteresPeriodica > 0 ? saldoPendiente * tasaInteresPeriodica : 0, // Saldo de intereses pendientes después del pago
    saldoCuota: cuotaFrecuencia[0], // Saldo de de la cuota actual mas deuda
    deuda: 0, // deuda de cuotas atrasadas con intereses
    deudaPaga: 0,
    abonos: []
   });

   // Incrementar la fecha de pago al siguiente período de pago
   fechaPeriodo = {
    diario: fechaPeriodo.endOf('day'),
    semanal: fechaPeriodo.add(1, 'week').subtract(1, 'day'),
    quincenal: fechaPeriodo.add(15, 'day').subtract(1, 'day'),
    mensual: fechaPeriodo.add(1, 'month').subtract(1, 'day')
   }[periodoPago];

   // Incrementar la fecha de pago a la siguiente frecuencia de pago
   fechaPago = {
    diario: fechaPago.endOf('day'),
    semanal: fechaPago.add(1, 'week').subtract(1, 'day'),
    quincenal: fechaPago.add(15, 'day').subtract(1, 'day'),
    mensual: fechaPago.add(1, 'month').subtract(1, 'day')
   }[frecuenciaPagos];

   esPeriodica = false;
  }

  // Calcular el total de intereses pagados sumando el interés pagado en cada período
  const totalInteresPagado = cuotasDetalladas.reduce((total, cuota) => total + cuota.interesPagado, 0);

  // Calcular el total pagado sumando la cuota fija de cada período
  const totalPagado = cuotasDetalladas.reduce((total, cuota) => total + cuota.cuotaFija, 0);

  // Calcular el porcentaje de ganancia comparando el total pagado con el monto principal
  //const porcentajeGanancia = ((totalPagado - principal) / principal) * 100;
  const porcentajeGanancia = (totalInteresPagado * 100) / totalPagado;

  // Devolver los resultados
  return {
   cuotasDetalladas: cuotasDetalladas,
   totalInteresPagado: totalInteresPagado,
   totalPagado: totalPagado,
   porcentajeGanancia: porcentajeGanancia,
   principal,
   tasaInteres,
   tiempo,
   periodoPago,
   primeraFecha,
   frecuenciaPagos
  };
 }

 async function aplicarAbonosYDeuda(cuotas, abonos) {
  const { cuotasDetalladas, tasaInteres, tiempo, frecuenciaPagos, periodoPago } = cuotas;
  let newDeuda = 0;
  let fecha = null;
  let periodos = 0;
  let newCuotas = [];
  const arrayDeCuotas = [];

  for (let i = 0; i < cuotasDetalladas.length; i++) {
   let cuota = { ...cuotasDetalladas[i], ...newCuotas.find(a => cuotasDetalladas[i]?.numeroCuota === a.numeroCuota) };
   let forma = null;
   let excedente = 0;
   let listAbonos = [];
   if (cuota.fechaPeriodo !== fecha) periodos++;

   if (cuota.fechaPeriodo !== fecha && newDeuda > 0) {
    const intrs = newDeuda * (tasaInteres / 100);
    cuota.deuda = newDeuda + intrs;
   } else if (newDeuda > 0) cuota.deuda = newDeuda;

   //console.log(newDeuda.toLocaleString(), cuota.deuda.toLocaleString());

   const montos = abonos
    .filter(e => dayjs(e.fechaAbono).isBetween(cuota.fechaPago, dayjs(cuota.fechaLimitePago), 'day', '[]'))
    .reduce((a, b, i, arr) => {
     listAbonos = arr;
     forma = b.formaPago;
     return a + b.montoAbono;
    }, 0);

   if (montos > 0) cuota.abonos = listAbonos;

   if (montos >= cuota.saldoCuota + Math.max(0, cuota.deuda - cuota.deudaPaga)) {
    excedente = montos - (cuota.saldoCuota + Math.max(0, cuota.deuda - cuota.deudaPaga));
    cuota = { ...cuota, saldoCuota: 0, deudaPaga: cuota.deuda, totalDeuda: 0 };
   } else if (montos >= Math.max(0, cuota.deuda - cuota.deudaPaga)) {
    excedente = montos - Math.max(0, cuota.deuda - cuota.deudaPaga);
    cuota = { ...cuota, deudaPaga: cuota.deuda, totalDeuda: 0 };
    if (excedente) {
     cuota = { ...cuota, saldoCuota: cuota.saldoCuota - excedente };
     excedente = 0;
    }
   } else if (montos > 0)
    cuota = { ...cuota, deudaPaga: cuota.deudaPaga + montos, totalDeuda: Math.max(0, cuota.deuda - cuota.deudaPaga - montos) };

   if (excedente && forma == 1) {
    let num = cuotasDetalladas.length - 1;
    while (excedente > 0 || num > 0) {
     const { saldoCuota } = cuotasDetalladas[num];
     const bi = Math.max(0, excedente - saldoCuota);
     if (bi > 0) cuotasDetalladas[num].saldoCuota = 0;
     else cuotasDetalladas[num].saldoCuota = saldoCuota - excedente;
     excedente = bi;
     num--;
    }
   } else if (excedente > 0)
    newCuotas = (
     await calcularCuotasDetalladas(
      cuotasDetalladas.filter(e => dayjs(e.fechaPago).isAfter(cuota.fechaPago)).reduce((a, b) => a + b.capitalPagado, -excedente),
      tasaInteres,
      tiempo - periodos,
      periodoPago,
      dayjs(cuota.fechaLimitePago).add(1, 'day').format('YYYY-MM-DD'),
      frecuenciaPagos,
      cuota.numeroCuota + 1
     )
    )?.cuotasDetalladas;

   if (dayjs(cuota.fechaLimitePago).isBefore(dayjs()) && cuota.saldoCuota)
    newDeuda = cuota.saldoCuota + Math.max(0, cuota.deuda - cuota.deudaPaga);
   else if (dayjs(cuota.fechaLimitePago).isBefore(dayjs()) && Math.max(0, cuota.deuda - cuota.deudaPaga) > 0)
    newDeuda = Math.max(0, cuota.deuda - cuota.deudaPaga);
   else newDeuda = 0;
   arrayDeCuotas.push(cuota);
  }
  console.log({ ...cuotas, cuotasDetalladas: arrayDeCuotas });
  return setData({ ...cuotas, cuotasDetalladas: arrayDeCuotas });
 }

 useEffect(() => {
  const subscription = watch(
   ({ principal, tasaInteres, tiempo, periodoPago, abonos, primeraFecha, frecuenciaPagos }, { name }) => {
    if (name === 'typeAbono')
     return aplicarAbonosYDeuda(
      calcularCuotasDetalladas(principal, tasaInteres, tiempo, periodoPago, primeraFecha, frecuenciaPagos),
      abonos
     );
    else return setData(calcularCuotasDetalladas(principal, tasaInteres, tiempo, periodoPago, primeraFecha, frecuenciaPagos));
   }
  );
  return () => subscription.unsubscribe();
 }, [watch]);

 useEffect(() => {
  console.log(data);
 }, [data]);

 return (
  <>
   <Row className="g-3 mt-0">
    <Col lg={9}>
     <Card>
      <Card.Body>
       <Row className="mb-3 g-3">
        <Input
         type="text"
         errors={errors}
         label="Fecha Inicial"
         name="primeraFecha"
         placeholder="Fecha de inicio"
         formGroupProps={{ as: Col, sm: { span: 2, offset: 0 } }}
         formLabelProps={{ className: 'mb-0 fs--1' }}
         formControlProps={{
          ...register('primeraFecha', { required: true }),
          className: 'text-center',
          autoComplete: 'off',
          disabled: false,
          size: 'sm'
         }}
        />
        <Input
         type="text"
         errors={errors}
         label="Prestamo"
         name="principal"
         placeholder="Monto a prestar"
         formGroupProps={{ as: Col, sm: { span: 2, offset: 0 } }}
         formLabelProps={{ className: 'mb-0 fs--1' }}
         formControlProps={{
          ...register('principal', { required: true }),
          className: 'text-center',
          autoComplete: 'off',
          disabled: false,
          size: 'sm'
         }}
        />
        <Input
         type="text"
         errors={errors}
         label="Interes"
         name="tasaInteres"
         placeholder="Tasa"
         formGroupProps={{ as: Col, sm: { span: 1, offset: 0 } }}
         formLabelProps={{ className: 'mb-0 fs--1' }}
         formControlProps={{
          ...register('tasaInteres', { required: true }),
          className: 'text-center',
          autoComplete: 'off',
          disabled: false,
          size: 'sm'
         }}
        />
        <Input
         type="text"
         errors={errors}
         label="Tiempo"
         name="tiempo"
         placeholder="tiempo del credito"
         formGroupProps={{ as: Col, sm: { span: 1, offset: 0 } }}
         formLabelProps={{ className: 'mb-0 fs--1' }}
         formControlProps={{
          ...register('tiempo', { required: true }),
          className: 'text-center',
          autoComplete: 'off',
          disabled: false,
          size: 'sm'
         }}
        />
        <Input
         type="select"
         name="periodoPago"
         label="Periodos"
         errors={errors}
         placeholder="Frecuencia del periodo"
         options={[
          { label: 'Diario', value: 'diario' },
          { label: 'Semanal', value: 'semanal' },
          { label: 'Quincenal', value: 'quincenal' },
          { label: 'Mensual', value: 'mensual' }
         ]}
         formGroupProps={{ as: Col, sm: { span: 3, offset: 0 } }}
         formLabelProps={{ className: 'mb-0 fs--1' }}
         formControlProps={{
          ...register('periodoPago', { required: true }),
          className: 'text-center',
          autoComplete: 'off',
          disabled: false,
          size: 'sm'
         }}
        />
        <Input
         type="select"
         name="frecuenciaPagos"
         label="Frecuencia"
         errors={errors}
         placeholder="Frecuencia del pago"
         options={[
          { label: 'Diario', value: 'diario' },
          { label: 'Semanal', value: 'semanal' },
          { label: 'Quincenal', value: 'quincenal' },
          { label: 'Mensual', value: 'mensual' }
         ]}
         formGroupProps={{ as: Col, sm: { span: 3, offset: 0 } }}
         formLabelProps={{ className: 'mb-0 fs--1' }}
         formControlProps={{
          ...register('frecuenciaPagos', { required: true }),
          className: 'text-center',
          autoComplete: 'off',
          disabled: false,
          size: 'sm'
         }}
        />
       </Row>

       <Row className="mb-3 g-3">
        <Input
         type="text"
         errors={errors}
         label="Fecha abono"
         name="abonos.0.fechaAbono"
         placeholder="Fecha del abono"
         formGroupProps={{ as: Col, sm: { span: 4, offset: 0 } }}
         formLabelProps={{ className: 'mb-0 fs--1' }}
         formControlProps={{
          ...register('abonos.0.fechaAbono', { required: true }),
          className: 'text-center',
          autoComplete: 'off',
          disabled: false,
          size: 'sm'
         }}
        />
        <Input
         type="text"
         errors={errors}
         label="Monto abono"
         name="abonos.0.montoAbono"
         placeholder="Monto a abonar"
         formGroupProps={{ as: Col, sm: { span: 4, offset: 0 } }}
         formLabelProps={{ className: 'mb-0 fs--1' }}
         formControlProps={{
          ...register('abonos.0.montoAbono', { required: true }),
          className: 'text-center',
          autoComplete: 'off',
          disabled: false,
          size: 'sm'
         }}
        />
        <Input
         type="select"
         name="typeAbono"
         label="Tipo de Abono"
         errors={errors}
         placeholder="Tipo de Abono"
         options={[
          { label: 'Tiempo Financiacion', value: '2' },
          { label: 'Cuotas Futuras', value: '1' }
         ]}
         formGroupProps={{ as: Col, sm: { span: 4, offset: 0 } }}
         formLabelProps={{ className: 'mb-0 fs--1' }}
         formControlProps={{
          ...register('typeAbono', { required: true }),
          className: 'text-center',
          autoComplete: 'off',
          disabled: false,
          size: 'sm'
         }}
        />
       </Row>

       {/* data && <TableContracts data={data} setData={() => console.log} product={{}} setProduct={() => console.log} /> */}
      </Card.Body>
     </Card>

     <Card className="my-3">
      <Background image={bg2} className="bg-card" />
      <Card.Body className="p-3">
       <Flex alignItems="center" wrap="wrap">
        <h6 className="fs-6 m-0 text-primary">F</h6>
        <div className="flex-1">
         <h4 className="m-0 text-primary">inanciacion</h4>
         <p className="fs--2 m-0">dksljfldskj fsjdflsdjlksjasksldl salk</p>
        </div>
        <div>
         <h6>Total Interes Pagado: {currency(data?.totalInteresPagado?.toString(), false, true, true)}</h6>
         <h6>Total Pagado: {currency(data?.totalPagado?.toString(), false, true, true)}</h6>
         <h6>Porcentaje Ganancia: {percent(data?.porcentajeGanancia, true, 2)[1]}</h6>
        </div>
       </Flex>
       <Row className="g-2">
        {data?.cuotasDetalladas?.length > 0 ? (
         data.cuotasDetalladas.map(({ numeroCuota, fechaPago, cuotaFija, ...res }, i) => (
          <Col
           sm={6}
           md={4}
           key={i}
           className={classNames('border-end border-end-400 mb-1 py-1', {
            'bg-soft-success': !(i % 2),
            'bg-soft-info': i % 2
           })}
          >
           {/* interesPagado capitalPagado saldoCapital saldoInteres montoAbonado fechaAbono */}
           <Dues num={numeroCuota} fechaPago={fechaPago} cuotaFija={cuotaFija} res={res} />
          </Col>
         ))
        ) : (
         <></>
        )}
       </Row>
      </Card.Body>
     </Card>
     {/* <Card className="bg-transparent shadow-none py-3">
      <Card.Body className="border-2 border-dashed border-400 border rounded text-center py-5">
       <div className="fs--1">
        <FontAwesomeIcon icon="exclamation-triangle" className="fs-6 mb-3" />
        <h5>¡No se han encontrado proyectos!</h5>
        <p className="mb-0">Su búsqueda no coincidió con ningún proyecto. Inténtalo de nuevo o crea un nuevo proyecto</p>
       </div>
      </Card.Body>
     </Card> */}
    </Col>
    <Col lg={3}>
     <div className="sticky-sidebar">
      {/* <Account setValue={setValue} watch={watch} /> */}
      <Card className="mb-3">
       <Card.Header className="pb-0">
        <Flex justifyContent="between">
         <div>
          <p className="mb-1 fs--2 text-500">Pruebalo gratis</p>
          <Flex>
           <div className="flex-1">
            <h5 className="mb-0 text-primary position-relative">
             <span className="pe-3">Nuevo Proyecto</span>
             <span className="border position-absolute top-50 translate-middle-y w-100 start-0 z-index--1"></span>
            </h5>
            <p className="mb-0 fs--2">Crear nunca fue tan facil.</p>
           </div>
          </Flex>
         </div>
         <div className="bg-soft-primary p-3 rounded-circle text-center" style={{ width: '60px', height: '60px' }}>
          <h5 className="text-primary mb-0 d-flex flex-column mt-n1">
           <span>30</span>
           <small className="text-primary fs--2 lh-1">DIAS</small>
          </h5>
         </div>
        </Flex>

        <ul className="fa-ul ms-2 ps-x1 mb-0 mt-3">
         <li className="py-0">
          <h6 className="text-700">
           <FontAwesomeIcon icon="check" className="fa-li text-success" />
           Ahorra tiempo
          </h6>
         </li>

         <li className="py-0">
          <h6 className="text-700">
           <FontAwesomeIcon icon="check" className="fa-li text-success" />
           Proyecta el futuro
          </h6>
         </li>

         <li className="py-0">
          <h6 className="text-700">
           <FontAwesomeIcon icon="check" className="fa-li text-success" />
           Estadisticas en tiempo real
          </h6>
         </li>
        </ul>
       </Card.Header>

       <Card.Body as={Flex} wrap="wrap" justifyContent="center" alignItems="center">
        <div className="flex-grow-1">
         <Link className="btn btn-sm btn-link ps-0" to="#!">
          Chatea con nosotros!
         </Link>
        </div>

        <div>
         <AvatarGroup dense>
          {[
           {
            id: 1,
            img: user1,
            size: 'xl'
           },
           {
            id: 2,
            img: user2,
            size: 'xl'
           },
           {
            id: 3,
            img: user3,
            size: 'xl'
           },
           {
            id: 4,
            name: '+50',
            size: 'xl'
           }
          ].map(({ img, name, size, id }) => {
           return (
            <Avatar
             src={img && img}
             key={id}
             size={size}
             name={name && name}
             isExact
             className="border border-3 rounded-circle border-light"
            />
           );
          })}
         </AvatarGroup>
        </div>
       </Card.Body>
       <Card.Footer>
        <div className="d-grid gap-2">
         <IconButton as={Link} icon="shapes" className="fs--1" transform="shrink-2" size="sm" variant="falcon-default" to="new">
          Crear Nuevo Proyecto
         </IconButton>
        </div>
       </Card.Footer>
      </Card>
     </div>
    </Col>
   </Row>
  </>
 );
};

export default Loans;
